import { useCallback } from 'react';
import {
  Link as BaseLink,
  NavigateOptions,
  NavLink as BaseNavLink,
  To,
  useNavigate as useBaseNavigate,
} from 'react-router';

import config from '@/config';

export function Link(props: React.ComponentProps<typeof BaseLink>) {
  return <BaseLink reloadDocument={isNewAppVersionAvailable()} {...props} />;
}

export function NavLink(props: React.ComponentProps<typeof BaseNavLink>) {
  return <BaseNavLink reloadDocument={isNewAppVersionAvailable()} {...props} />;
}

export function useNavigate() {
  const navigate = useBaseNavigate();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      /**
       * In case of special navigation options (like `state` or `replace`), it's safer to let the base navigate function handle it.
       */
      if (options) {
        return navigate(to, options);
      }

      if (typeof to === 'string' && to.startsWith('/') && isNewAppVersionAvailable()) {
        window.location.href = to;

        return;
      }

      return navigate(to, options);
    },
    [navigate]
  );
}

function isNewAppVersionAvailable(): boolean {
  if (!config.appVersion.startsWith('20') || !window.appVersionLatest?.startsWith('20')) {
    // Either the current version or the latest app version are not in the expected format (iso date + commit hash).
    // This should not happen, but if it does, we play it safe and assume no new version is available.

    return false;
  }

  // We want the current version to be the same as the latest version.
  // In case of a rollback of the app version, we also want users to reload. (Which is why we check != instead of <)

  return config.appVersion !== window.appVersionLatest;
}
